import { render, staticRenderFns } from "./CustomerAddress.vue?vue&type=template&id=7153543f&scoped=true"
import script from "./CustomerAddress.vue?vue&type=script&lang=js"
export * from "./CustomerAddress.vue?vue&type=script&lang=js"
import style0 from "./CustomerAddress.vue?vue&type=style&index=0&id=7153543f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_17bc9983cdb7459b16429e97d92f86dc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7153543f",
  null
  
)

export default component.exports